import { TablePagination } from '@octano/global-ui';
import { usePerformanceAnalysisList } from './PerformanceAnalysisListLoader';

export interface PerformanceAnalysisTablePaginationProps {
  total: number;
  totalPages: number;
}

export function PerformanceAnalysisTablePagination({
  total,
  totalPages,
}: PerformanceAnalysisTablePaginationProps) {
  const { query, updateQuery } = usePerformanceAnalysisList();

  return (
    <TablePagination
      pagination={{
        currentPage: query.page,
        itemsPerPage: 10,
        onChangePage: (page) => {
          updateQuery({ ...query, page });
        },
        totalItems: total,
        totalPages: totalPages,
      }}
    />
  );
}
